import React from "react";
import "./Introduction.css";
import { ThemeContext } from "../../Context/theme";
import profilePic from "../../assets/nayan.jpg";
import { IoMdExit } from "react-icons/io";
 

export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src={profilePic} alt="Images" />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, I,m {" "}
                <span className="different">Chandan Kumar </span> from{" "}
                <span className="different">
                  {" "}
                  Saran, Bihar, (India).
                </span>
                I have completed my B.Tech in Mechanical Engineering from{" "}
                <span className="different">W.B.U.T, Kolkata(West Bengal)
                </span>
                Currently I'm working as a{" "}
                <span className="different">Java Back-end Developer (Microservices)</span> in Texala,Pune
              </h4>
              <h4> Some of my interests apart form Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <IoMdExit />
                </span>
                Music{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <IoMdExit />
                </span>
                Coding{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <IoMdExit />
                </span>
                Open Source Contribution{" "}
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
